export { CVCIcon } from "./cvc";
